import React, { useEffect } from 'react';
import { postJson, deleteJson } from '../helpers/RequestsHelper';
import SelectObject from '../pages/WorkflowComponents/Inputs/SelectObject'
import TextInput from '../pages/WorkflowComponents/Inputs/TextInput'
import NumberInput from '../pages/WorkflowComponents/Inputs/NumberInput'


const ActiveExecutionsForm = (props) => {

  const [item] = React.useState(props.item)
  const [block] = React.useState(props.block)
  const [inputs, setInputs] = React.useState()
  const [entries, setEntries] = React.useState({})

  const executionInput = async () => {
    await postJson(process.env.REACT_APP_SERVER_BASE_URL + "/workflows/input/" + item.id, entries)
    props.onUpdate(item)
  }

  useEffect(() => {
    if (!inputs) {
      const params = props.block.params
      if (params.inputs && params.inputs.input) {
        setInputs(params.inputs.input)
      } else {
        setInputs([])
      }
    }
  }, [props.block]);


  const onSelect = (key, selected) => {
    var newEntries = entries
    newEntries[key] = selected.value
    setEntries(entries)
  }

  const onPropertyInput = (key, value) => {
    var newEntries = entries
    newEntries[key] = value
    setEntries(entries)
  }

  const onDelete = async () => {
    await deleteJson(process.env.REACT_APP_SERVER_BASE_URL + "/workflows/input/" + item.id)
    props.onUpdate(item)
  }

  if (!inputs) {
    return ""
  }

  return (
    <div className="apps-group">
      {Object.entries(inputs).map(([key, input]) => {

        //TODO: Find better approach
        const fieldId = key// key.replace("input.", "")

        switch (input.datatype) {
          case "bool":
            const items =
              [
                { id: "choice1", value: input.choice1 ? input.choice1 : "Choice 1" },
                { id: "choice2", value: input.choice2 ? input.choice2 : "Choice 2" }
              ]
            return <>
              {input.value} <br />
              <SelectObject items={items} fieldName="value" onSelect={(selected) => onSelect(fieldId, selected)} selected={items.find(a => a.value === entries[fieldId])} />
            </>
          case "text":
            return <>
              {input.value} <br />
              <TextInput value={entries[fieldId]} onChange={(value) => onPropertyInput(fieldId, value)} />
            </>
          case "number":
            return <>
              {input.value} <br />
              <NumberInput value={entries[fieldId]} onChange={(value) => onPropertyInput(fieldId, value)} />
            </>
          default:
            break;
        }
      })}
      <br/>
      <div className="d-flex justify-content-center">
        <div class="p-2">
          <button className="submit-btn-2" onClick={executionInput}>Submit</button>
        </div>

        <div class="p-2">
          <button className="submit-btn-2 p-2" onClick={onDelete}>Cancel</button>
        </div>
      </div>
    </div>
  )
}

export default ActiveExecutionsForm